import { useT } from '../i18n';
import { saveSettings } from '../store/session';
import { useSettings } from '../store/settings';

/** One-tap switch between light and dark (resolves "System" to whatever is showing now). */
export function ThemeToggle({ className = 'icon-btn' }: { className?: string }) {
  const t = useT();
  const theme = useSettings((s) => s.settings.theme);
  const showing = theme === 'system' ? (matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark') : theme;
  const next = showing === 'dark' ? 'light' : 'dark';
  return (
    <button className={className} onClick={() => void saveSettings({ theme: next })} aria-label={next === 'light' ? t('theme.toLight') : t('theme.toDark')} title={next === 'light' ? t('theme.toLight') : t('theme.toDark')}>
      <span aria-hidden="true">{showing === 'dark' ? '☀️' : '🌙'}</span>
    </button>
  );
}
